import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "descr",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = {
  for: "category",
  class: "kn-material-input-label"
}
const _hoisted_14 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_15 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_16 = { class: "p-float-label" }
const _hoisted_17 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_18 = { class: "p-field p-col-12 p-lg-6" }
const _hoisted_19 = { class: "p-float-label" }
const _hoisted_20 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_21 = { class: "p-col-12 p-lg-4 p-mt-3" }
const _hoisted_22 = { class: "p-as-center" }
const _hoisted_23 = {
  for: "baseLayer",
  class: "kn-material-input-label p-ml-2"
}
const _hoisted_24 = { class: "p-field p-col-12 p-lg-4" }
const _hoisted_25 = { class: "p-float-label" }
const _hoisted_26 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_27 = { class: "p-field p-col-12 p-lg-4" }
const _hoisted_28 = { class: "p-float-label" }
const _hoisted_29 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_30 = { class: "p-col-12" }
const _hoisted_31 = { class: "p-float-label" }
const _hoisted_32 = {
  for: "layerRoles",
  class: "kn-material-input-label"
}
const _hoisted_33 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_34 = { class: "p-field p-col-12" }
const _hoisted_35 = { class: "p-float-label" }
const _hoisted_36 = {
  for: "layerType",
  class: "kn-material-input-label"
}
const _hoisted_37 = {
  key: 0,
  class: "p-field p-col-12 p-d-flex"
}
const _hoisted_38 = { class: "kn-flex" }
const _hoisted_39 = { class: "p-float-label" }
const _hoisted_40 = {
  for: "fileName",
  class: "kn-material-input-label"
}
const _hoisted_41 = {
  key: 1,
  class: "p-field p-col-12"
}
const _hoisted_42 = { class: "p-float-label" }
const _hoisted_43 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_44 = { class: "p-float-label" }
const _hoisted_45 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_46 = {
  key: 3,
  class: "p-field p-col-12 p-lg-6"
}
const _hoisted_47 = { class: "p-float-label" }
const _hoisted_48 = {
  for: "label",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_Button = _resolveComponent("Button")
  const _component_KnInputFile = _resolveComponent("KnInputFile")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, { id: "basic-info-card" }, {
      content: _withCtx(() => [
        _createVNode("form", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InputText, {
                id: "label",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.layer.label.$invalid && _ctx.v$.layer.label.$dirty
                            }],
                type: "text",
                maxLength: "100",
                modelValue: _ctx.v$.layer.label.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.layer.label.$model = $event)),
                onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.layer.label.$touch())),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.layer.label,
              additionalTranslateParams: { fieldName: _ctx.$t('common.label') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("span", _hoisted_6, [
              _createVNode(_component_InputText, {
                id: "name",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.layer.name.$invalid && _ctx.v$.layer.name.$dirty
                            }],
                type: "text",
                maxLength: "100",
                modelValue: _ctx.v$.layer.name.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.layer.name.$model = $event)),
                onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.layer.name.$touch())),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.layer.name,
              additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("span", _hoisted_9, [
              _createVNode(_component_Textarea, {
                id: "descr",
                class: "kn-material-input",
                rows: "1",
                maxLength: "100",
                autoResize: true,
                modelValue: _ctx.layer.descr,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.layer.descr = $event)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.description')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("span", _hoisted_12, [
              _createVNode(_component_Dropdown, {
                id: "category",
                class: "kn-material-input",
                modelValue: _ctx.layer.category_id,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.layer.category_id = $event)),
                options: _ctx.allCategories,
                optionLabel: "VALUE_NM",
                optionValue: "VALUE_ID",
                showClear: true,
                onChange: _ctx.onTypeChange
              }, null, 8, ["modelValue", "options", "onChange"]),
              _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('common.category')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, {
      id: "basic-layer-options-card",
      class: "p-mt-3"
    }, {
      content: _withCtx(() => [
        _createVNode("form", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            _createVNode("span", _hoisted_16, [
              _createVNode(_component_InputText, {
                id: "label",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.layer.layerLabel.$invalid && _ctx.v$.layer.layerLabel.$dirty
                            }],
                type: "text",
                maxLength: "100",
                modelValue: _ctx.v$.layer.layerLabel.$model,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.layer.layerLabel.$model = $event)),
                onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.layer.layerLabel.$touch())),
                onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('managers.layersManagement.layerLabel')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.layer.layerLabel,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.layersManagement.layerLabel') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("span", _hoisted_19, [
              _createVNode(_component_InputText, {
                id: "name",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.layer.layerName.$invalid && _ctx.v$.layer.layerName.$dirty
                            }],
                type: "text",
                maxLength: "100",
                modelValue: _ctx.v$.layer.layerName.$model,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.layer.layerName.$model = $event)),
                onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.v$.layer.layerName.$touch())),
                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('managers.layersManagement.layerName')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.layer.layerName,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.layersManagement.layerName') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("span", _hoisted_22, [
              _createVNode(_component_InputSwitch, {
                id: "baseLayer",
                modelValue: _ctx.layer.baseLayer,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.layer.baseLayer = $event))
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('managers.layersManagement.baseLayer')), 1)
            ])
          ]),
          _createVNode("div", _hoisted_24, [
            _createVNode("span", _hoisted_25, [
              _createVNode(_component_InputText, {
                id: "name",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.layer.layerIdentify.$invalid && _ctx.v$.layer.layerIdentify.$dirty
                            }],
                type: "text",
                maxLength: "100",
                modelValue: _ctx.v$.layer.layerIdentify.$model,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.v$.layer.layerIdentify.$model = $event)),
                onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.v$.layer.layerIdentify.$touch())),
                onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('managers.layersManagement.layerIdentify')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.layer.layerIdentify,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.layersManagement.layerIdentify') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_27, [
            _createVNode("span", _hoisted_28, [
              _createVNode(_component_InputText, {
                id: "name",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.layer.layerOrder.$invalid && _ctx.v$.layer.layerOrder.$dirty
                            }],
                type: "number",
                min: "0",
                modelValue: _ctx.v$.layer.layerOrder.$model,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.v$.layer.layerOrder.$model = $event)),
                onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.v$.layer.layerOrder.$touch())),
                onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "class"]),
              _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('managers.layersManagement.layerOrder')) + " * ", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.layer.layerOrder,
              additionalTranslateParams: { fieldName: _ctx.$t('managers.layersManagement.layerOrder') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          _createVNode("div", _hoisted_30, [
            _createVNode("span", _hoisted_31, [
              _createVNode(_component_MultiSelect, {
                id: "layerRoles",
                class: "kn-material-input",
                modelValue: _ctx.layer.roles,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.layer.roles = $event)),
                options: _ctx.allRoles,
                optionLabel: "name",
                display: "chip",
                filter: true
              }, null, 8, ["modelValue", "options"]),
              _createVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('common.roles')), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Card, {
      id: "layer-type-card",
      class: "p-mt-3"
    }, {
      content: _withCtx(() => [
        _createVNode("form", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode("span", _hoisted_35, [
              _createVNode(_component_Dropdown, {
                id: "layerType",
                class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.layer.type.$invalid && _ctx.v$.layer.type.$dirty
                            }],
                modelValue: _ctx.v$.layer.type.$model,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.v$.layer.type.$model = $event)),
                options: _ctx.layerTypes,
                optionLabel: "label",
                optionValue: "value",
                disabled: _ctx.layer.layerId,
                onBlur: _cache[25] || (_cache[25] = ($event: any) => (_ctx.v$.layer.type.$touch())),
                onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "options", "class", "disabled"]),
              _createVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('common.type')) + " *", 1)
            ]),
            _createVNode(_component_KnValidationMessages, {
              class: "p-mt-1",
              vComp: _ctx.v$.layer.type,
              additionalTranslateParams: { fieldName: _ctx.$t('common.type') }
            }, null, 8, ["vComp", "additionalTranslateParams"])
          ]),
          (_ctx.layer.type == 'File')
            ? (_openBlock(), _createBlock("div", _hoisted_37, [
                _createVNode("div", _hoisted_38, [
                  _createVNode("span", _hoisted_39, [
                    _createVNode(_component_InputText, {
                      id: "fileName",
                      class: "kn-material-input",
                      modelValue: _ctx.layer.pathFile,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.layer.pathFile = $event)),
                      disabled: true
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('managers.layersManagement.fileLocation')), 1)
                  ])
                ]),
                _createVNode(_component_Button, {
                  icon: "fas fa-upload",
                  class: "p-button-text p-button-plain p-ml-2",
                  onClick: _ctx.setUploadType
                }, null, 8, ["onClick"]),
                (!_ctx.uploading)
                  ? (_openBlock(), _createBlock(_component_KnInputFile, {
                      key: 0,
                      changeFunction: _ctx.uploadLayerFile,
                      accept: ".json",
                      triggerInput: _ctx.triggerUpload
                    }, null, 8, ["changeFunction", "triggerInput"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.layer.type == 'WFS' || _ctx.layer.type == 'WMS' || _ctx.layer.type == 'TMS')
            ? (_openBlock(), _createBlock("div", _hoisted_41, [
                _createVNode("span", _hoisted_42, [
                  _createVNode(_component_InputText, {
                    id: "label",
                    class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.layer.layerURL.$invalid && _ctx.v$.layer.layerURL.$dirty
                            }],
                    type: "text",
                    maxLength: "100",
                    modelValue: _ctx.v$.layer.layerURL.$model,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.v$.layer.layerURL.$model = $event)),
                    onBlur: _cache[29] || (_cache[29] = ($event: any) => (_ctx.v$.layer.layerURL.$touch())),
                    onChange: _cache[30] || (_cache[30] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('managers.layersManagement.layerURL')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.layer.layerURL,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.layersManagement.layerURL') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.layer.type == 'Google' || _ctx.layer.type == 'WMS' || _ctx.layer.type == 'TMS')
            ? (_openBlock(), _createBlock("div", {
                key: 2,
                class: [{ 'p-lg-6': _ctx.layer.type == 'WMS', 'p-lg-12': _ctx.layer.type != 'WMS' }, "p-field p-col-12 p-lg-6"]
              }, [
                _createVNode("span", _hoisted_44, [
                  _createVNode(_component_InputText, {
                    id: "label",
                    class: "kn-material-input",
                    type: "text",
                    maxLength: "100",
                    modelValue: _ctx.layer.layerOptions,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.layer.layerOptions = $event)),
                    onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('managers.layersManagement.layerOptions')), 1)
                ])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.layer.type == 'WMS')
            ? (_openBlock(), _createBlock("div", _hoisted_46, [
                _createVNode("span", _hoisted_47, [
                  _createVNode(_component_InputText, {
                    id: "label",
                    class: "kn-material-input",
                    type: "text",
                    maxLength: "100",
                    modelValue: _ctx.layer.layerParams,
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.layer.layerParams = $event)),
                    onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('managers.layersManagement.layerParams')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ], 64))
}